var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSpacer = function SvgSpacer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 190
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.9%",
    y: "-2.8%",
    width: "107.8%",
    height: "107.7%",
    filterUnits: "objectBoundingBox",
    id: "space_r_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-3.3%",
    y: "-2.2%",
    width: "106.7%",
    height: "106.6%",
    filterUnits: "objectBoundingBox",
    id: "space_r_svg__c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    "in": "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0",
    "in": "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-6.2%",
    y: "-3.6%",
    width: "112.5%",
    height: "114.3%",
    filterUnits: "objectBoundingBox",
    id: "space_r_svg__d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "space_r_svg__b",
    cx: 89.872,
    cy: 90.899,
    rx: 89.872,
    ry: 90.899
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "space_r_svg__e",
    cx: 89.872,
    cy: 90.86,
    rx: 76.163,
    ry: 77.105
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#space_r_svg__a)",
    xlinkHref: "#space_r_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#002D41",
    xlinkHref: "#space_r_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#space_r_svg__c)",
    xlinkHref: "#space_r_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#space_r_svg__d)",
    xlinkHref: "#space_r_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#414F76",
    xlinkHref: "#space_r_svg__e"
  })), /*#__PURE__*/React.createElement("text", {
    className: "space_r_svg__virtualBox_TextInSvg",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 39.6,
    letterSpacing: -0.477,
    fill: "#FFF",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 51,
    y: 103
  }, "\u7A7A\u683C")))));
};

export default SvgSpacer;